/**
 * TanStack Router: /onboarding
 *
 * This route file was auto-generated by the route generation script.
 * Component: OnboardingPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import OnboardingPage from '@/app/onboarding/page'

/**
 * Route: /onboarding
 * Layout: _auth (authenticated)
 * Component: OnboardingPage
 */
export const Route = createFileRoute('/_auth/onboarding/')({
  component: OnboardingPage,
})
